export const selectProduct = [
  {
    path: `/SelectProduct`,
    name: `SelectProduct`,
    redirect: `/SelectProduct/add`,
    hidden: true,
    component: () => import('@/views/Home'),
    children: [
      {
        path: '/SelectProduct/add/:subId/:groupId/:projectId/:seriesId/:groupName/:isService',
        name: '/SelectProduct/add',
        component: () => import('@/views/selectproduct/SelectProduct')
      }
    ]
  }
];
